import { Moon, Sun } from 'lucide-react'
import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

import { useTheme } from './theme-context'

/**
 * Alterna entre escuro (padrão) e claro. Variante `ghost`: o amarelo da marca
 * é reservado ao CTA principal e ao item ativo da sidebar.
 */
export function ThemeToggle(): ReactElement {
  const { tema, alternarTema } = useTheme()
  const rotulo = tema === 'dark' ? 'Mudar para o tema claro' : 'Mudar para o tema escuro'

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon" onClick={alternarTema} aria-label={rotulo}>
          {tema === 'dark' ? (
            <Sun className="size-4" aria-hidden="true" />
          ) : (
            <Moon className="size-4" aria-hidden="true" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{rotulo}</TooltipContent>
    </Tooltip>
  )
}
